<section class="cui-dialog">
  <header class="cui-dialog__header">
    <h1>Terms of Service</h1>
    <cui-dialog-close-button />
  </header>
  <div class="cui-dialog__content">
    <h2>English</h2>
    <p>
      Access to Hephaestus is strictly limited to authorized users holding a valid contractual
      relationship with Tensor AI Solutions GmbH. The specific scope of use, rights, and obligations
      is governed exclusively by the individual service agreements concluded between the respective
      parties. Any unauthorized access, use, or attempt to bypass security measures is strictly
      prohibited and may result in legal action.
    </p>
    <h2>Deutsch</h2>
    <p>
      Der Zugang zu Hephaestus ist ausschließlich autorisierten Nutzern vorbehalten, die in einem
      gültigen Vertragsverhältnis mit der Tensor AI Solutions GmbH stehen. Der spezifische
      Nutzungsumfang sowie die Rechte und Pflichten ergeben sich ausschließlich aus den jeweiligen
      individuellen schriftlichen Vertragsverhältnissen (z. B. Rahmenverträgen oder
      Leistungsbeschreibungen) zwischen den Vertragsparteien. Jegliche unbefugte Nutzung, unbefugter
      Zugriff oder der Versuch, Sicherheitsvorkehrungen zu umgehen, ist strengstens untersagt und
      wird kann rechtlich verfolgt werden.
    </p>
  </div>
</section>
